import closeIcon from 'assets/icons/icon-close-12.svg';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { useIntl } from 'react-intl';
import { Button, SearchIcon } from 'shared/components';
import { useListSearch, useMobile } from 'shared/hooks';
import { ListSearchResults } from './ListSearchResults';

interface Props {
  query: string;
  recentSearchLocalStorageKey: string;
  selector?: string;
  onSetQuery: (query: string) => void;
}

export const ListSearch: React.FC<Props> = ({
  query,
  recentSearchLocalStorageKey,
  selector,
  onSetQuery,
}) => {
  const { formatMessage } = useIntl();
  const isMobile = useMobile();
  const {
    inputRef,
    showResults,
    wrapperRef,
    isInputVisible,
    toggleInput,
    handleSearch,
    setShowResults,
    handleClickInside,
  } = useListSearch(query, onSetQuery);
  const isSearchButtonVisible = !isInputVisible && !isMobile && !query;

  return (
    <div ref={wrapperRef} className="list-search-search__wrapper">
      <AnimatePresence>
        {isSearchButtonVisible ? (
          <Button
            type="button"
            style="outline"
            className="u-width--36 u-height--36"
            btnSelector={`${selector}-list-search-btn`}
            onClick={toggleInput}
          >
            <SearchIcon />
          </Button>
        ) : (
          <div className="u-pos--rel">
            <motion.input
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3, delay: 0.15 }}
              className="input input__text list-search__input"
              type="text"
              data-cy={`${selector}-list-search-input`}
              placeholder={formatMessage({
                id: `${selector}.search`,
              })}
              ref={inputRef}
              autoFocus={isMobile ? false : true}
              value={query}
              onChange={handleSearch}
              onClick={handleClickInside}
              onFocus={() => !isMobile && setShowResults(true)}
            />
            {showResults && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3, delay: 0.15 }}
                onClick={toggleInput}
                className="list-search__close__icon"
              >
                <img
                  src={closeIcon}
                  alt="Close icon"
                  data-cy={`${selector}-list-search-cancel-icon`}
                />
              </motion.div>
            )}
          </div>
        )}
      </AnimatePresence>
      {showResults && (
        <ListSearchResults
          recentSearchLocalStorageKey={recentSearchLocalStorageKey}
          isMobile={isMobile}
          query={query}
          selector={selector}
          onSetQuery={onSetQuery}
        />
      )}
    </div>
  );
};
